module.exports = __webpack_public_path__ + "img/syjt.4464dc2a.png";